import { render, staticRenderFns } from "./CaminhadaInscrevase.vue?vue&type=template&id=4e3af606&scoped=true&"
import script from "./CaminhadaInscrevase.vue?vue&type=script&lang=js&"
export * from "./CaminhadaInscrevase.vue?vue&type=script&lang=js&"
import style0 from "./CaminhadaInscrevase.vue?vue&type=style&index=0&id=4e3af606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3af606",
  null
  
)

export default component.exports